export interface UserUpdateDetailsResponse {
    success: boolean;
    description: string;
}
